<template>
    <div>
        <!-- NFC not capable alert -->
        <b-alert v-if="!NFC_capability" show variant="warning">
            <i class="fa-solid fa-circle-exclamation"></i>
            <span style="padding-left: 10px">This devices is not Web NFC capable.</span>
        </b-alert>

        <!-- scan button -->
        <button type="button" v-b-modal.modal-nfc style="float: right;" class="btn btn-primary btn-sm" @click="scanTest()">
            <i class="fa-solid fa-mobile-screen-button"></i>
            <span style="padding-left: 10px">Scan</span>
        </button>

        <!-- scan modal -->
        <b-modal id="modal-nfc" size="md" title="">
            <div style="text-align: center; color: #8e8e8e;">
                <div v-if="!NFC_capability">
                    <div class="modal-nfc-heading">Scan Error <i style="color: #fe301f;" class="fa-regular fa-circle-xmark"></i></div>
                    <img src="../assets/images/NFC_scan_error.png">
                    <div class="modal-nfc-sub-heading">Unable to start NFC scan.</div>
                    <div class="modal-nfc-info">(This devices is not Web NFC capable).</div>
                </div>                    
                <div v-else-if="!scanning && !scanError">
                    <div class="modal-nfc-heading">Ready to Scan</div>
                    <img src="../assets/images/NFC_scan_start.png">
                    <div class="modal-nfc-sub-heading">Hold your phone near the object to scan.</div>
                </div>
                <div v-else>
                    <div id="scan-complete-heading" class="modal-nfc-heading">Scan Complete <i style="color: #49C752" class="fa-regular fa-circle-check"></i></div>
                    <div id="scan-complete">
                        <img class="animate__animated" src="../assets/images/NFC_scan_complete.png">
                        <div class="modal-nfc-sub-heading">NFC scan successful!</div>
                    </div>
                    <div id="nfc-map" class="animate__animated animate__fadeIn" style="display: none">
                        <div id="device-info-box">
                            <img style="display: inline-block; float: left; width: 70px; height: 70px; vertical-align: top;" src="../assets/images/MIoT.png" alt="...">
                            <div style="display: inline-block; float: left; padding-left: 10px; text-align: left; font-size: 11px;;">
                                <div style="font-size: 20px; font-weight: 700;">{{ NFC.name }}</div>
                                <b>Serial:</b> {{ NFC.serial }}
                                <br />
                                <b>UUID:</b>  {{ nfc_text_data }}
                            </div>
                        </div>
                        <div style="float: left; width: 100%; text-align: left; font-size: 11px; padding-top: 10px">
                            <b>Date Time:</b> {{ datetime | moment('MMMM Do YYYY, h:mm:ss a') }} AEDT
                        </div>
                        <div style="float: left; width: 100%; text-align: left; font-size: 11px;">
                            <b>User:</b> {{ $parent.userName }}
                        </div>
                        <div style="float: left; width: 100%;">
                            <google-map-test ref="googleMaps"/>
                        </div>
                    </div>
                </div>
            </div>
            <template #modal-footer>
                <button v-if="!scanning" v-b-modal.moda-nfc-close_visit class="btn btn-sm btn-secondary" @click="$bvModal.hide('modal-nfc')">Cancel</button>
                <button v-else v-b-modal.moda-nfc-close_visit class="btn btn-sm btn-primary" @click="$bvModal.hide('modal-nfc')">Done</button>
            </template>                                
        </b-modal>

        <br /><br />

        <!-- log -->
        <div style="font-size: 15px;"><b>Scan Logging</b></div>
        <div style="font-size: 10px;"> 
            <table>
                <tr v-for="item in NFC_activityLog" v-bind:key="item.id">
                    <td><b>{{ item.timestamp | moment("HH:MM:SS") }}</b> </td>
                    <td>- {{ item.msg }}</td>
                </tr>
            </table>
        </div>

        <br />

        <!-- clear log button -->
        <button type="button" style="float: left;" class="btn btn-secondary btn-sm" @click="clearLog()">
            Clear Log
        </button>

    </div>
</template>

<script>
    import googleMapTest from '@/components/googleMapTest.vue';

    export default {
        name: 'nfc',
        components: {
            googleMapTest
        },         
        data: function () {
            return {
                showmap: false,
                test: "nfc dev",
                ndef: null,
                abortController: null,
                NFC_capability: false,
                NFC_activityLog: [],
                scanning: false,
                scanError: false,
                NFC: {
                    serial: "xx:xx:xx:xx",
                    name: "not set"
                },
                scanStarted: false,
                scanComplete: false,
                location :null,
                gettingLocation: false,
                errorStr: null,
                latitude: null,
                longitude: null,
                datetime: "not set",
                nfc_text_data: null,
            };
        },
        props: [],
        watch: {},
        methods: {      
            async scanTest() {
                this.log("scanTest button clicked!");
                this.scanError = false;
                this.scanning = false;
                this.scanComplete = false;
                this.showmap = false;
                
                if(!this.scanStarted) {
                    try {
                        // Start scanning
                        await this.ndef.scan();

                        this.log("Scan started (v2.0.0)");

                        this.ndef.addEventListener("readingerror", () => {
                            this.log("Argh! Cannot read data from the NFC tag. Try another one?");
                        });

                        this.ndef.addEventListener("reading", async ({ message, serialNumber }) => {
                            if(!this.scanComplete) {
                                this.scanning = true;
                                this.NFC.serial = serialNumber;

                                // set name based on serial
                                if(this.NFC.serial == '63:cc:1b:c0') {
                                    this.NFC.name = "Smart Packaging Device 1";
                                } else if(this.NFC.serial == 'd3:e3:1b:c0') {
                                    this.NFC.name = "Smart Packaging Device 2";
                                } else if(this.NFC.serial == '73:9a:17:c0') {
                                    this.NFC.name = "Freeze Test - Tag 1";
                                } else if(this.NFC.serial == '13:1f:1a:c0') {
                                    this.NFC.name = "Freeze Test - Tag 2";
                                } else if(this.NFC.serial == '13:15:2f:c0') {
                                    this.NFC.name = "Freeze Test - Tag 3";
                                } else {
                                    this.NFC.name = "unknown (not registered)"
                                }

                                // Read Tag
                                this.log("Reading Tag");
                                this.log("-------- NFC TAG DATA --------");
                                this.log("Serial Number: " + serialNumber);
                                this.log("Records: " + message.records.length);

                                // inspect messages
                                for (const record of message.records) {
                                    this.log("Record type: " + record.recordType);
                                    this.log("MIME type: " + record.mediaType);
                                    this.log("Record id: " + record.id);
                                    switch (record.recordType) {
                                    case "text":
                                        var textDecoder = new TextDecoder(record.encoding);
                                        console.log(`Text: ${textDecoder.decode(record.data)} (${record.lang})`)
                                        this.log(`Text: ${textDecoder.decode(record.data)} (${record.lang})`);
                                        this.nfc_text_data = textDecoder.decode(record.data);
                                        break;
                                    case "url":
                                        // TODO: Read URL record with record data.
                                        this.log("DOMString: " + record.DOMString);
                                        break;
                                    default:
                                        // TODO: Handle other records with record data.
                                    }
                                    this.log("Record: " + record);
                                    this.log("Record Data: " + record.data);

                                    // set datetime
                                    this.datetime = new Date();
                                    
                                    const delay = ms => new Promise(res => setTimeout(res, ms));

                                    await delay(1000);
                                    document.getElementById("scan-complete").classList.add("animate__fadeOut");

                                    await delay(1000);
                                    document.getElementById("scan-complete-heading").classList.add("scan-complete-heading-adjusted");
                                    document.getElementById("scan-complete-heading").style.display = 'none';
                                    document.getElementById("scan-complete").style.display = 'none';
                                    console.log("after 2 sec");
                                    document.getElementById("nfc-map").style.display = 'block';
                                    this.$refs.googleMaps.locateMe();
                                }
                                this.log("------------------------------");

                                this.scanComplete = true;
                            }
                        });
                    } catch (error) {
                        this.scanError = true;
                        this.log("Device is NOT NFC Capable (" + error + ")");

                        // // FOR TESTING
                        // console.log("TESTING OVERRIDES!")
                        // this.NFC_capability = true;
                        // this.scanning = true;
                        // this.scanError = false;
                        // this.scanComplete = true;

                        // // set datetime
                        // this.datetime = new Date();

                        // const delay = ms => new Promise(res => setTimeout(res, ms));

                        // await delay(1000);
                        // document.getElementById("scan-complete").classList.add("animate__fadeOut");

                        // await delay(1000);
                        // document.getElementById("scan-complete-heading").classList.add("scan-complete-heading-adjusted");
                        // document.getElementById("scan-complete-heading").style.display = 'none';
                        // document.getElementById("scan-complete").style.display = 'none';
                        // console.log("after 2 sec");
                        // document.getElementById("nfc-map").style.display = 'block';
                        // this.$refs.googleMaps.locateMe();
                        // // END - FOR TESTING
                    }
                    this.scanStarted = true;
                }
            },
            log(msg) {
                var log = {id: this.$parent.uuidv4(), timestamp: new Date(), msg: msg};
                console.log(log);
                this.NFC_activityLog.push(log);
            },
            clearLog() {
                this.NFC_activityLog = []
            },
        },
        mounted: function () {
            // start logging
            this.log("Logging started");
            this.log("Checking if device is NFC capable");

            // check NFC capability
            try {
                this.ndef = new NDEFReader();
                this.log("Mounted - check ok!");
                this.log("Device is NFC Capable");
                this.NFC_capability = true;
            } catch(error) {
                this.log("ERROR! Device is NOT NFC Capable (" + error + ")");
            }
        }
    }
</script>

<style scoped>
    body.modal-open .modal {
        display: flex !important;
        height: 100% !important;
    } 

    body.modal-open .modal .modal-dialog {
        margin: auto !important;
    }

    .scan-complete-heading-adjusted {
        font-size: 23px !important;
        padding-top: 0px !important;
        margin-bottom: 15px !important;
    }

    #modal-nfc .modal-dialog {
        min-width: 375px;;
    }    

    #modal-nfc img {
        height: 230px;
    }

    .modal-nfc-heading {
        font-size: 29px;
        padding-top: 14px;
        margin-bottom: 28px;
    }

    .modal-nfc-sub-heading {
        font-size: 19px !important;
        margin-top: 30px;
        margin-bottom: 8px;
    }

    .modal-nfc-info {
        font-size: 15px;
    }

    .modal-nfc-sub-info {
        font-size: 10px;
        margin-bottom: 8px;
    }

    @media (max-width: 767px) {
        #modal-nfc .modal-dialog {
            min-width: initial;;
        }    
    }
</style>    

